function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{opacity:0.4;fill:#F2F2F2;enable-background:new    ;}\n\t.st1{opacity:0.9;fill:#F2F2F2;enable-background:new    ;}\n\t.st2{fill:#333333;}\n");

var _ref3 =
/*#__PURE__*/
React.createElement("path", {
  className: "st0",
  d: "M0.6,121.5l0,82.5c0,22.1,15.5,31,34.6,20l71.4-41.2c19.1-11,34.6-37.9,34.6-60V40.3c0-22.1-15.5-31-34.6-20 L35.2,61.5C16.1,72.6,0.6,99.4,0.6,121.5z"
});

var _ref4 =
/*#__PURE__*/
React.createElement("path", {
  className: "st1",
  d: "M16.8,129.6l0,82.5c0,22.1,15.5,31,34.6,20l71.4-41.2c19.1-11,34.6-37.9,34.6-60V48.4c0-22.1-15.5-31-34.6-20 L51.5,69.6C32.3,80.7,16.8,107.5,16.8,129.6z"
});

var _ref5 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st2",
  d: "M52,143.8c-0.9,0.5-1.6,1.3-2.1,2.4c-0.5,1-0.7,2.3-0.7,3.6c0,2.9,0.9,3.8,2.8,2.7c0.8-0.5,1.7-1.2,2.8-2.3 l0,2.3c-0.9,1-1.9,1.8-3.1,2.4c-1.6,0.9-2.9,1.1-3.7,0.4c-0.9-0.6-1.3-2-1.3-4.1c0-1.3,0.2-2.6,0.6-3.9c0.4-1.3,1-2.4,1.8-3.4 c0.8-1,1.7-1.8,2.8-2.4c1.1-0.6,2.2-0.9,3.3-1l-0.8,2.7c-0.4,0-0.8,0.1-1.3,0.1C52.8,143.4,52.4,143.6,52,143.8z M67.3,139.3 c0,2.1-0.5,4-1.4,5.7c-0.9,1.7-2.2,3-3.9,4c-1.7,1-3,1.2-3.9,0.6c-0.9-0.6-1.4-2-1.4-4.1c0-2.1,0.5-4,1.4-5.7c0.9-1.7,2.2-3,3.9-4 c1.7-1,3-1.2,3.9-0.6C66.8,135.8,67.3,137.2,67.3,139.3z M59.2,144c0,1.4,0.2,2.4,0.7,2.8c0.5,0.5,1.2,0.4,2.1-0.1 c1.9-1.1,2.8-3.1,2.8-6c0-2.9-0.9-3.8-2.8-2.7c-0.9,0.5-1.6,1.3-2.1,2.3C59.4,141.3,59.2,142.5,59.2,144z M74.3,141.7l-2.7-8.5 l-0.1,0c0.1,2,0.1,3.3,0.1,4l0,6l-2.1,1.2l0-12.8l3.2-1.9l2.6,8.3l0,0l2.8-11.4l3.2-1.9l0,12.8l-2.2,1.3l0-6.1c0-0.3,0-0.6,0-1 c0-0.4,0-1.4,0.1-3l-0.1,0l-2.9,11.7L74.3,141.7z M89,133.2l-2.7-8.5l-0.1,0c0.1,2,0.1,3.3,0.1,4l0,6l-2.1,1.2l0-12.8l3.2-1.9 l2.6,8.3l0,0L93,118l3.2-1.9l0,12.8l-2.2,1.3l0-6.1c0-0.3,0-0.6,0-1c0-0.4,0-1.4,0.1-3l-0.1,0l-2.9,11.7L89,133.2z M105.4,123.7 l-6.4,3.7l0-12.8l6.4-3.7l0,2.2l-4,2.3l0,2.8l3.8-2.2l0,2.2l-3.8,2.2l0,3.3l4-2.3L105.4,123.7z M110.1,113.9l0.8-0.4 c0.7-0.4,1.3-0.9,1.7-1.4c0.4-0.5,0.5-1,0.5-1.7c0-0.6-0.2-0.9-0.5-1c-0.4,0-0.9,0.1-1.7,0.6l-0.7,0.4L110.1,113.9z M110.1,116.1 l0,4.9l-2.4,1.4l0-12.9l3.2-1.9c1.5-0.9,2.6-1.2,3.4-1c0.7,0.2,1.1,1,1.1,2.3c0,0.8-0.2,1.5-0.5,2.3c-0.4,0.8-0.9,1.5-1.5,2.3 c1.7,1.9,2.8,3.2,3.3,3.7l-2.6,1.5l-2.7-3.4L110.1,116.1z M122.3,103.2c-0.9,0.5-1.6,1.3-2.1,2.4c-0.5,1-0.7,2.3-0.7,3.6 c0,2.9,0.9,3.8,2.8,2.7c0.8-0.5,1.7-1.2,2.8-2.3v2.3c-0.9,1-1.9,1.8-3.1,2.4c-1.6,0.9-2.9,1.1-3.7,0.4c-0.9-0.6-1.3-2-1.3-4.1 c0-1.3,0.2-2.6,0.6-3.9c0.4-1.3,1-2.4,1.8-3.4c0.8-1,1.7-1.8,2.8-2.4c1.1-0.6,2.2-0.9,3.3-1l-0.8,2.7c-0.4,0-0.8,0.1-1.3,0.1 S122.7,102.9,122.3,103.2z M133.2,107.7l-6.4,3.7l0-12.8l6.4-3.7l0,2.2l-4,2.3l0,2.8l3.8-2.2l0,2.2l-3.8,2.2l0,3.3l4-2.3 L133.2,107.7z"
}));

var SvgCommercial = function SvgCommercial(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 158 253",
    style: {
      enableBackground: "new 0 0 158 253"
    },
    xmlSpace: "preserve",
    width: 158,
    height: 253,
    ref: svgRef
  }, props), React.createElement("title", null, title), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgCommercial, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Commercial.5d3d709d.svg";
export { ForwardRef as ReactComponent };